<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'1-10'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>시스템 관리 - 혜택 관리</p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn02" v-on:click="edit">수정</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='benefits_join_point'>회원가입 포인트<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'benefits_join_point'
                maxLength="13"
                placeholder = "회원가입 포인트를 입력해 주세요."
                v-model="formData.benefitsJoinPoint"
                @input="formatPoint"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_benefits,
  update_benefits
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminBenefitsManagement',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner
  },
  data () {
    return {
      statusData: ref({
        spinnerStatus: false
      }),
      formData: ref({
        benefitsJoinPoint: '0'
      })
    }
  },
  methods: {
    formatPoint () {
      let value = this.formData.benefitsJoinPoint.replace(/\D/g, '')
      value = Number(value).toLocaleString()
      this.formData.benefitsJoinPoint = value
    },
    edit () {
      update_benefits(
        this.formData.benefitsJoinPoint.replace(/\D/g, '')
      ).then(result_data => {
        alert('수정이 완료되었습니다.')
      })
    }
  },

  mounted () {
    get_benefits().then(result_data => {
      this.formData.benefitsJoinPoint = result_data[0].benefits_join_point.toLocaleString()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SystemManagement/AdminBenefitsManagement.vue